import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { Role } from '../enums/role.enum';
import { RbsService } from 'src/app/services/rbs/rbs.service';
import { catchError, map, of, take } from 'rxjs';
import { FormattedOrganizationInRole } from 'src/app/services/rbs/interfaces/formatted-organization-in-role.interface';

export const RoleGuard: (redirectUrl: string) => CanActivateFn =
  (redirectUrl: string) => (route: ActivatedRouteSnapshot) => {
    const router = inject(Router);
    const rbsService = inject(RbsService);

    const requiredRoles = route.data['roles'] as Role[];

    const notAuthorizedUrlTree = router.createUrlTree(['not-authorized']);

    if (!Array.isArray(requiredRoles) || !requiredRoles.length) {
      return notAuthorizedUrlTree;
    }

    return rbsService.getSelectedRoleInOrganization().pipe(
      take(1),
      map((response: FormattedOrganizationInRole | undefined) => {
        let userRole = response?.serviceRole?.name as Role;

        if (!Object.values(Role).includes(userRole)) {
          return notAuthorizedUrlTree;
        }

        const redirectUrlTree = router.createUrlTree([redirectUrl]);

        return requiredRoles.includes(userRole) || redirectUrlTree;
      }),
      catchError(() => of(notAuthorizedUrlTree))
    );
  };
